import React, {FunctionComponent} from 'react';
import './SelectListItem.less';
import {SelectListItemName} from 'elements/select-list-item-name/SelectListItemName';
import {ClickIcon} from '../../elements/click-icon/ClickIcon';
// @ts-ignore
import InfoIcon from 'new-images/info.svg';

interface SelectListItemProps {
	name: string,
	description?: string,
	checkboxControl?: JSX.Element,
	control?: JSX.Element,
	isSelected: boolean,
	isDisabled: boolean,
	onClick?: () => void,
	onDescriptionClick?: (description: string, event: any) => void,
}

export const SelectListItem: FunctionComponent<SelectListItemProps> = (
	{
		name,
		description,
		checkboxControl,
		control,
		isSelected,
		isDisabled,
		onClick,
		onDescriptionClick
	}) => {
	return <li className={`select-list-item ${
		isSelected ? 'select-list-item--selected' : ''
	} ${
		isDisabled ? 'select-list-item--disabled' : ''
	}`}
						 onClick={isDisabled ? undefined : onClick}
	>
		{
			checkboxControl && (
				<div className="select-list-item__checkbox">
					{checkboxControl}
				</div>
			)
		}
		<div className="select-list-item__name">
			<SelectListItemName text={name} isDisabled={isDisabled}/>
		</div>
		{
			control && (<div className="select-list-item__control">
				{control}
			</div>)
		}
		{
			description?.length > 0 && (<div className="select-list-item__description">
				<ClickIcon icon={InfoIcon} onClick={(e) => onDescriptionClick(description, e)}/>
			</div>)
		}
	</li>;
};
